const DOCTOR_KEYWORDS = [
  "dr",
  "doctor",
  "physician",
  "clinician",
  "examiner",
  "expert",
];

/** Doctor or patient, by displayed name; shared by transcript and search (MDRS-538). */
export const speakerTypeFor = (speaker: string): "doctor" | "patient" => {
  const words = speaker.toLowerCase().split(/[^a-z]+/);
  return DOCTOR_KEYWORDS.some((keyword) => words.includes(keyword))
    ? "doctor"
    : "patient";
};
